import React from 'react'
import { Link } from 'gatsby'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'

import ProductCardMini from "../components/product-card-mini"
import useGetAllProduct from '../hooks/useGetAllProduct'

import background from '../images/homepage/trending-offers-background.png'

export default function TrendingOffers({ title, products, ids }) {
    const allProduct = useGetAllProduct()
    const getProductById = (id) => allProduct.find(({ node }) => node.productId === id).node
    products = products ? products : ids.map(getProductById)

    return (
        <Container fluid className="bg-dark pb-5" style={{
            backgroundImage: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        }}>
            <Container>
                <h2 className="text-uppercase text-white pt-5 mb-4">
                    {title ? title : 'Trending Offers'}
                </h2>

                {/* TRENDING PRODUCTS */}
                <Row className="mb-4">
                    {products.map(product => <ProductCardMini product={product} key={`trending-offer-product-card-mini-${product?.id}`} />)}
                </Row>

                {/* BUTTON (LINK) TO SALE */}
                <div className="text-center">
                    <Link to='/sale' className="d-inline-block ff-primary text-white text-uppercase border border-white border-2 px-5 py-2" style={{ fontSize: 18 }}>
                        VIEW ALL SALE PRODUCTS
                    </Link>
                </div>
            </Container>
        </Container>
    )
}